<template>
  <div :class="getStyleClasses(type)" class="p-2 rounded border-4">
    <div class="max-w-default mx-auto">
      <span v-if="icon" class="pr-1" :class="icon"></span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: { type: String, default: 'info' },
    icon: { type: String, default: '' },
  },
  methods: {
    getStyleClasses(type) {
      var styles = {
        warning: 'bg-yellow-300 border-yellow-600 text-black',
        error: 'bg-red-300 border-red-600 text-black',
        success: 'bg-green-300 border-green-600 text-black',
        info: 'bg-blue-200 border-blue-600 text-black',
        null: 'bg-blue-200 border-blue-600 text-black',
      };
      return styles[type];
    },
  },
};
</script>
